<template>
    <div>
        <a
            class="btn btn-sm is-ghost px-2xl is-danger"
            @click="$modal.show(modalName)"
        >
            Radera
        </a>
        <adaptive-form-modal
            :name="modalName"
            primary-button-text="Radera export"
            primary-button-class="is-danger"
            title="Radera export"
            :callback="reloadPage"
            method="delete"
            :action="route('api.exports.delete', this.export)"
        >
            Är du säker på att du vill radera exportfilen?
        </adaptive-form-modal>
    </div>
</template>

<script>
    export default {
        props: {
            export: {
                type: Object,
                required: true,
            },
        },
        computed: {
            modalName() {
                return `delete-export-${this.export.id}`;
            },
        },
        methods: {
            reloadPage() {
                window.location = window.location.href;
            },
        },
    };
</script>
